module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "center big-padding"
  }, [_vm._v("\n    Souhaitez-vous supprimer le cantonnier "), _c('strong', [_vm._v(_vm._s(_vm.cantonnier.nom) + " " + _vm._s(_vm.cantonnier.prenom) + " ")]), _vm._v(" - "), _c('strong', [_vm._v(_vm._s(_vm._f("arrondissementName")(_vm.cantonnier.arrondissement_id)))]), _vm._v(" ? Cela aura pour effet de ne plus l'afficher dans la liste des cantonniers disponible, par le maîtrise, lors de la phase de configuration initiale d'une session de travail.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("\n      Supprimer\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      Annuler\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-96e17186!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/cantonniers/CantonniersDelete.vue
// module id = 2124
// module chunks = 2